import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import { IMessage, showMessage } from '../actions/message';

/**
 * メッセージのState型
 */
export interface IMessageState {
	readonly open: boolean;
	readonly messages: IMessage[];
	readonly title: string;
}

/**
 * メッセージのState初期値
 */
const initialState: IMessageState = {
	messages: [],
	open: false,
	title: '',
};

/**
 * メッセージ用reducer
 * @param state State
 * @param action アクション
 */
const message = (state: IMessageState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, showMessage)) {
		return {
			...state,
			messages: action.payload.messages,
			open: action.payload.messages.length !== 0,
			title: action.payload.title,
		};
	}

	return state;
};

export default message;



// WEBPACK FOOTER //
// ./src/reducers/message.ts